import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CaseOverviewWrapper',
  setup(__props) {

const showMaps = ref<boolean>(false);
const onMapsClick = () => {
  showMaps.value = true;
};
const onGridClick = () => {
  showMaps.value = false;
};
const onMoveToTopClick = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    showMaps: showMaps.value,
    onMapsClick: onMapsClick,
    onGridClick: onGridClick,
    onMoveToTopClick: onMoveToTopClick
  })
}
}

})